/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
'use client';

import * as Accordion from '@radix-ui/react-accordion';
import React from 'react';
import { cn } from '@/app_lib/utils/utils';

const Root = React.forwardRef<
  React.ComponentRef<typeof Accordion.Root>,
  React.ComponentPropsWithoutRef<typeof Accordion.Root>
>(({ className, children, ...rest }, ref) => (
  <Accordion.Root
    className={cn(className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Root>
));
Root.displayName = 'AccordionRoot';

const Header = React.forwardRef<
  React.ComponentRef<typeof Accordion.Header>,
  React.ComponentPropsWithoutRef<typeof Accordion.Header>
>(({ className, children, ...rest }, ref) => (
  <Accordion.Header
    className={cn(className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Header>
));
Header.displayName = 'AccordionHeader';

const Item = React.forwardRef<
  React.ComponentRef<typeof Accordion.Item>,
  React.ComponentPropsWithoutRef<typeof Accordion.Item>
>(({ className, ...rest }, ref) => (
  <Accordion.Item
    className={cn(className)}
    ref={ref}
    {...rest}
  />
));
Item.displayName = 'AccordionItem';

type RadixTriggerProps = React.ComponentPropsWithoutRef<typeof Accordion.Trigger>;
interface TriggerProps extends RadixTriggerProps {
  headerClassName?: string;
}
// TODO: This needs to be redone. Probably the whole component, but definitely at least the Trigger shouldn't have the header in it
const Trigger = React.forwardRef<React.ComponentRef<typeof Accordion.Trigger>, TriggerProps>(
  ({ headerClassName, className, children, ...props }, ref) => (
    <Accordion.Header className={cn('flex text-current', headerClassName)}>
      <Accordion.Trigger
        className={cn(
          'cursor-pointer accordion-header [&[data-state=open]>svg]:rotate-180 hover:text-brand-primary group text-current',
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </Accordion.Trigger>
    </Accordion.Header>
  ),
);
Trigger.displayName = 'AccordionTrigger';

type RadixContentProps = React.ComponentPropsWithoutRef<typeof Accordion.Content>;
interface ContentProps extends RadixContentProps {
  parentClassName?: string;
}

const Content = React.forwardRef<React.ComponentRef<typeof Accordion.Content>, ContentProps>(
  ({ parentClassName, className, children, ...props }, ref) => (
    <Accordion.Content
      className={cn(
        'accordion-body data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
        parentClassName,
      )}
      ref={ref}
      {...props}
    >
      <div className={cn(className)}>{children}</div>
    </Accordion.Content>
  ),
);
Content.displayName = 'AccordionContent';

export { Root, Header, Item, Trigger, Content };
